export default __webpack_public_path__ + "static/scoreboard-2dfbef125813071f3c22bbf0ab05ae1e.png";